<script>
    export let value;
    export let placeholder = '';
    export let required = false;
    export let cssClass = '';
    export let id = '';
    export let warnOnEmpty = false;
    export let onChange = () => {
    };

    let bgColor = '';

    const onInputChange = () => {
        value = value.replace(",", ".");
        onChange(value, id);
    }

    $: bgColor = (warnOnEmpty && (value == null || value == '')) ? 'warn-on-empty' : '';
</script>

<input type="text" class="form-control { cssClass } {bgColor}" id="{ id }" bind:value="{ value }"
       oninput="this.value = this.value.replace(/[^0-9.,]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
       on:change="{ onInputChange }"
       autocomplete="off"
       {placeholder}
       {required}
/>

<style>
    .warn-on-empty {
        background: rgba(255, 0, 0, 0.06);
    }
</style>
